import script from "./user-addresses.vue?vue&type=script&setup=true&lang=js"
export * from "./user-addresses.vue?vue&type=script&setup=true&lang=js"

import "./user-addresses.vue?vue&type=style&index=0&id=7735e5f0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7735e5f0"]])

export default __exports__